import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=649c9cd6&"
import script from "./Create.vue?vue&type=script&lang=js&"
export * from "./Create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('649c9cd6')) {
      api.createRecord('649c9cd6', component.options)
    } else {
      api.reload('649c9cd6', component.options)
    }
    module.hot.accept("./Create.vue?vue&type=template&id=649c9cd6&", function () {
      api.rerender('649c9cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/Create.vue"
export default component.exports